<template>
    <div>
    	<div class="map_btn_realcity_simplemap" v-show="this.selectedTopMenu == 'Realcity'">
    		<a class="btn_txt" href="#" @click.prevent="initSeoulmap()">전체보기</a>
    	</div>
        <div class="map_btn_realcity_simplemap2" v-if="Object.keys(this.selectedAreaData).length > 0 && this.selectedTopMenu == 'Realcity'">
            <a class="btn_txt" href="#" @click.prevent="showSelectedSeoulmapPop()">팝업</a>
        </div>


        <!-- <div class="map_btn_realcity_simplemap" v-show="this.selectedTopMenu == 'Realcity' && this.showTopBar">
            <a class="btn_txt" href="#" @click.prevent="initSeoulmap()">{{ this.selectedAreaData.key }}</a>
        </div> -->

    </div>
</template>

<script>
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { $_TYPE, $_WC } from '@/confs/common.const.js';
import { mapGetters } from "vuex";
import gripUtil from "@/libs/grip.util.js"
import axios from 'axios'

export default {
    name: 'seoulmap-map-ctrl',
    components: {
    },
    data(){
		return {
 			instance: undefined,
			selectedArea: '',
			selectedAreaData: {},
			centerMap: {},
			apiKey: $_WC.seoulmapApiKey,
			colorMap: {
				'붐빔': {color: '#DD1F3D', marker: 'marker_real_4.png'},
				'약간 붐빔': {color: '#FF8040', marker: 'marker_real_3.png'},
				'보통': {color: '#FFB100', marker: 'marker_real_2.png'},
				'여유': {color: '#00D369', marker: 'marker_real_1.png'},
			},
			polygon: undefined,
		    loading: false,
		    left: false,
		    showTopBar: false,
		}
    },
    created() {
/*     	this.$eventBus.$on('SeoulmapDataLoader:loaded-data', function(map) {
			this.initSeoulmap();
    	}.bind(this));

    	this.$eventBus.$on('SeoulmapDataLoader:reloaded-data', function() {
    		// 선택이 안되어있으면 그냥 초기화
    		// 차후에 문제되면 동작 잡아서 처리해야할듯?
    		if(this.selectedArea === ''){
    			this.initSeoulmap();
    		} else {
    			this.getOpenapiData();
    		}
    	}.bind(this)); */
    },
    mounted() {
        this.$eventBus.$on('SeoulmapMapCtrl::realcity-map-button-style', function(showChart) {
            if(showChart) {
                if($_WC.viewScale > 1) {
                    this.left = true;
                } else {
                    this.left = true;
                }
            } else {
                this.left = false;
            }
        }.bind(this));
    },
    watch: {
        selectedMarker: {
            immediate: false,
            handler(newVal, oldVal) {
            	// 마커 클릭 시 center 이동
//            	if(typeof newVal !== 'undefined' && typeof newVal.position !== 'undefined'){
//            		this.map.setCenter(newVal.position);
//            	}
            }
        },
        selectedTopMenu: {
            immediate: true,
            handler(newVal, oldVal) {
                /* if(newVal !== 'safety') {
                    this.closeInfoWin;
                } */
                if(typeof this.geoJsonDrawing != 'undefined') {
                    this.geoJsonDrawing.setDefaultFillColor();
                    // 폴리곤 삭제하는 로직 필요.
                    for(let key in this.geoJsonDrawing.polygonMap) {
                        let polygon = this.geoJsonDrawing.polygonMap[key].polygons[0];
                        if(polygon.getVisible()) {
                            polygon.setVisible(false);
                        }
                    }
                    if(this.selectedTopMenu === 'Realcity') {
                        this.$eventBus.$emit("ChangeLoading::State::Loading");
						this.initSeoulmap();
                    } else {
                        this.disableAllPolyline();
                        this.removeMarker('seoulmap');
                        this.removePolygon('seoulmap');
						this.$eventBus.$emit("SeoulmapMapCtrl::close-population-pop");
                        if(typeof this.geoJsonDrawing.seoulmapPolygon !== 'undefined') {
                            let seoulPolyMap = this.geoJsonDrawing.seoulmapPolygon;
                            for(let key in seoulPolyMap) {
                                if(seoulPolyMap[key][0].getVisible()) {
                                    seoulPolyMap[key][0].setVisible(false);
                                    this.removePolygonSeoulmap();
                                }
                            }
                        }
                        for(let key in this.geoJsonDrawing.polygonMap) {
                            let polygon = this.geoJsonDrawing.polygonMap[key].polygons[0];
                            if(!polygon.getVisible()) {
                                polygon.setVisible(true);
                            }
                        }
                    }
                }
            }
        },
        /* selectedSubMenus: {
            immediate: true,
            handler: function(newVal, oldVal) {
            }
        }, */
    },
    computed: {
		...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
			realtimeCityList: 'getRealtimeCityList',
			facilitiesMenu: 'getFacilitiesMenu',
			realtimeCityMap: 'getRealtimeCityMap',
		}),
    	// realtimeCityMap: function(){
		// 	return gripUtil.toDict(this.realtimeCityList, 'val1');
    	// },
    	subMenu() {
            if(this.selectedSubMenus.length > 0) {
                return this.selectedSubMenus[0];
            }
        },
    },
    methods: {
    	drawPolygonSeoulmap(feature){
    		let paths = [];
			let coordinates = feature.geometry.coordinates;
			if(feature.geometry.coordinates.length === 1){
				coordinates = feature.geometry.coordinates[0];
			}
			coordinates.forEach((coordinate, index) => {
				coordinate.forEach((coord) => {
				    coord.forEach((d) => {
    					if(typeof paths[index] === 'undefined'){
    						paths[index] = [];
    					}
    					paths[index].push(new naver.maps.LatLng(d[1], d[0]));
				    });

				});
			});

            this.polygon = new naver.maps.Polygon({
                paths: paths,
                fillColor: '#b0b0b0',
                fillOpacity: 0.5,
                strokeColor: '#b0b0b0',
                strokeOpacity: 0.5,
                strokeWeight: (1 * $_WC.viewScale),
            });
            this.polygon.setMap(this.map);
            if(typeof this.geoJsonDrawing.seoulmapPolygon == 'undefined') {
                this.geoJsonDrawing.seoulmapPolygon = {};
            }
            this.geoJsonDrawing.seoulmapPolygon = this.polygonMap;
    	},
    	drawIndividualSeoulmap(feature){
            let paths = [];
            let coordinates = feature.geometry.coordinates;
            if(feature.geometry.coordinates.length === 1){
                coordinates = feature.geometry.coordinates[0];
            }
            coordinates.forEach((coordinate, index) => {
                coordinate.forEach((d) => {
                    if(typeof paths[index] === 'undefined'){
                        paths[index] = [];
                    }
                    paths[index].push(new naver.maps.LatLng(d[0], d[1]));
                });
            });

            this.polygon = new naver.maps.Polygon({
                paths: paths,
                fillColor: '#b0b0b0',
                fillOpacity: 0.5,
                strokeColor: '#b0b0b0',
                strokeOpacity: 0.5,
                strokeWeight: (1 * $_WC.viewScale),
            });

            if(typeof this.polygonMap['seoulmap'] == 'undefined') {
                this.polygonMap['seoulmap'] = [];
            }
            this.polygonMap['seoulmap'].push(this.polygon);
            this.polygon.setMap(this.map);
        },
    	removePolygonSeoulmap(){
    		if(typeof this.polygon !== 'undefined'){
    			this.polygon.setMap(null);
            	this.polygon = undefined;
    		}
    	},
    	drawPolygonCongestion(){
    		this.instance.get($_WC.assets + "geojson/hotspot/hotspot.json").then((res) => {
				this.$store.dispatch('FETCH_REALTIME_CITY_LIST').then(() => {

					res.data.features.forEach((feature) => {
						// console.log('feature', feature);
						let areaKey = feature.properties.hotspotNm;
						if(typeof this.realtimeCityMap[areaKey] !== 'undefined'){
							this.centerMap[areaKey] = feature.properties.center;
							let data = this.realtimeCityMap[areaKey];
							let color = this.colorMap[data.val2].color;
							let imgFileNm = this.colorMap[data.val2].marker;

							// 폴리곤
							this.makePolygonByStringReverse(this.geoJsonKeyType.prop, 'hotspotNm', feature, color, 0.6, function(key, event){
								this.selectedArea = key;
								this.getOpenapiData();
							}.bind(this), undefined);

							// 마커
							let markerData = {key: areaKey, lttdVal: feature.properties.center[0], lgtdVal: feature.properties.center[1]};
							let marker = this.makeMarker(areaKey, markerData, function(event, data, marker){
								this.selectedArea = data.key;
								this.getOpenapiData();
							}.bind(this), imgFileNm, '/img/marker2/', 30, 30);


							// html마커
							let anchorVal = 30 * $_WC.viewScale;
							let circleSize = 240;
							if($_WC.isMobile) {
								circleSize = 10;
							}
							let circleHtml = this.makeHtmlMarkerSeoul('', areaKey, '');
							var circle = new naver.maps.Marker({
								position: new naver.maps.LatLng(feature.properties.center[0], feature.properties.center[1]),
								map: this.map,
								title: data.key,
								icon: {
									content: circleHtml,
									size: new naver.maps.Size(circleSize, circleSize),
									anchor: new naver.maps.Point(anchorVal, anchorVal),
								},
								// animation: naver.maps.Animation.BOUNCE
							});

							naver.maps.Event.addListener(circle, 'click', function(event) {
								this.selectedArea = areaKey;
								this.getOpenapiData();
							}.bind(this));


							this.addMarkerMap('Realtime-circle', circle);

							let infoWindow = this.makeHoverInfo(areaKey);

							// hover event를 위한 추가
							// 모바일 및 4K 제외함 -> 터치 시 팝업이 남아있음.
							if(!$_WC.isMobile && $_WC.viewScale == 1) {
								naver.maps.Event.addListener(marker, "mouseover", function() {
									infoWindow.open(this.map, marker);
								}.bind(this));
								naver.maps.Event.addListener(marker, "mouseout", function() {
									infoWindow.close(this.map, marker);
								}.bind(this));
							}

							this.addMarkerMap('seoulmap-area-key', marker);

							marker.setTitle(areaKey);

						} else {
							// console.log('error', areaKey);
						}
					});
					this.showMarkers('seoulmap-area-key', true);
					this.showMarkers('Realtime-circle', false);
					this.$eventBus.$emit("ChangeLoading::State::Loaded");

					// this.showMarkers('Realtime-circle', true);
					/* for(let k in this.markerMap){
						this.showMarkers(k, true);
					} */
				});
    		});
    	},
    	clearSeoulmap(){
    		for(let mapKey in this.polygonMap){
    			this.removePolygon(mapKey);
    		}
    		this.removePolygonSeoulmap();
    		// this.disableAllMarker();
    		this.disableMarker('seoulmap');
    		this.disableMarker('seoulmap-area-key');

			let zoom = 13;
			if($_WC.isMobile) {
				zoom = 12;
			}
            this.map.setZoom(zoom);
    		this.map.setCenter(new naver.maps.LatLng(37.495408, 127.060313));

    		this.$eventBus.$emit("SeoulmapMapCtrl::loaded-seoulmap-data", {});
    	},
    	initSeoulmap(){
			this.selectedAreaData = {};
    		this.clearSeoulmap();
    		this.disableAllMarker();
    		this.left = false;
    		this.showTopBar = false;
			this.$eventBus.$emit("SeoulmapMapCtrl::close-population-pop");
            if(typeof this.instance === 'undefined'){
            	this.instance = axios.create();
            }
            this.instance.get($_WC.assets + "geojson/adarea/" + $_WC.geojsonPath + '/sig_reverse.json').then((res) => {
            	res.data.features.forEach((feature) => {
            		this.drawPolygonSeoulmap(feature);
            	});
				this.drawPolygonCongestion();
            });
            if(!!this.facilitiesMenu) {
                this.facilitiesMenu['Realcity'].forEach(function(d) {
                    d.isChecked = false;
                })
            }

			// this.$eventBus.$emit("Close::Seoulmap:Detail::Win", false);
    	},

    	selectArea(){
    		this.clearSeoulmap();
    		if(!!this.facilitiesMenu) {
                this.facilitiesMenu['Realcity'].forEach((d) => {
                    d.isChecked = false;
                })
            }

    		this.instance.get($_WC.assets + "geojson/hotspot/getHotspot.json").then((res) => {
	        	res.data.features.forEach((feature) => {
	        		if(this.selectedArea === feature.properties.hotspotNm){
	        			let zoom = Number(feature.properties.zoom) + 6;
						if($_WC.isMobile) {
							zoom = zoom - 1;
						}
						let mapCenterX = this.centerMap[this.selectedArea][0];
						let mapCenterY = this.centerMap[this.selectedArea][1];
						if($_WC.viewScale > 1) {
							mapCenterY = mapCenterY + 0.002;
						}
        				this.drawIndividualSeoulmap(feature);
        	    		this.map.setCenter(new naver.maps.LatLng(mapCenterX, mapCenterY));
        	        	this.map.setZoom(zoom);
        	        	this.$eventBus.$emit("SeoulmapMapCtrl::loaded-seoulmap-data", this.selectedAreaData);
        	        	this.$eventBus.$emit("SeoulmapMapCtrl::show-seoulmap-pop");

        	        	if(!!this.facilitiesMenu) {
        	        	    this.facilitiesMenu['Realcity'].forEach((d) => {
        	        	        if(!d.isChecked) {
            	        	        d.isChecked = true;
        	        	        }
        	        	    })
        	        	}
        	        	this.showMarkers('Realtime-circle', true);
	        		}
	        	});
	        });
    	},
    	getOpenapiData(){
    		this.selectedAreaData = {};
			this.$eventBus.$emit("ChangeLoading::State::Loading");

    		// let url = 'http://openapi.seoul.go.kr:8088/' + this.apiKey + '/xml/citydata/1/5/' + encodeURIComponent(this.selectedArea);
            // 캐시 사용을 위해서 컨트롤러 콜로 변경
			// let url = $_WC.apiBaseURL + '/seoulCity/realcity?areaNm=' + encodeURIComponent(this.selectedArea) + '&apiKey=' + this.apiKey;
			// let url = 'http://dev.ydns.co.kr:1680/gncitizen/api/seoulCity/realcity?areaNm=' + encodeURIComponent(this.selectedArea) + '&apiKey=' + this.apiKey;

            // 자료 적재로 변경함
            let url = $_WC.apiBaseURL + '/repos/' + this.$_DKD.REALTIME_CITY_XML + '/data?where=val1::' + encodeURIComponent(this.selectedArea) + '&isUnescape=true';
    		if(typeof this.instance === 'undefined'){
            	this.instance = axios.create();
            }
            this.instance.get(url).then((res) => {
                if(res.data.data.length > 0) {
                    let data = res.data.data[0];

                    let xmlParser = new DOMParser();
                    let xmlDoc = xmlParser.parseFromString(data.val11, "text/xml");

                    // let xmlNode = new DOMParser().parseFromString(data.val11, "text/xml");

                    this.selectedAreaData = {
                        key: this.selectedArea,
                        ROAD_TRAFFIC_STTS: this.xmlParser(xmlDoc, 'ROAD_TRAFFIC_STTS'),
                        AVG_ROAD_DATA: this.xmlGetDataMap(xmlDoc, 'AVG_ROAD_DATA'),
                        PRK_STTS: this.xmlParser(xmlDoc, 'PRK_STTS'),
                        SUB_STTS: this.xmlParser(xmlDoc, 'SUB_STTS'),
                        BUS_STN_STTS: this.xmlParser(xmlDoc, 'BUS_STN_STTS'),
                        ACDNT_CNTRL_STTS: this.xmlParser(xmlDoc, 'ACDNT_CNTRL_STTS'),
                        SBIKE_STTS: this.xmlParser(xmlDoc, 'SBIKE_STTS'),
                        WEATHER_STTS: this.xmlParser(xmlDoc, 'WEATHER_STTS'),
                        COVID_19_STTS: this.xmlParser(xmlDoc, 'COVID_19_STTS'),
                        FCST_PPLTN: this.xmlParser(xmlDoc, 'FCST_PPLTN'),
                        LIVE_PPLTN_STTS: this.xmlParser(xmlDoc, 'LIVE_PPLTN_STTS'),
                        CHARGER_STTS: this.xmlParser(xmlDoc, 'CHARGER_STTS'),
                        EVENT_STTS: this.xmlParser(xmlDoc, 'EVENT_STTS'),
                        estimatePop: this.xmlGetData(xmlDoc, 'FCST_YN'),
                        popKey: '1',
                    };
                    console.log( data.basdtVal, this.selectedAreaData );
                    if (Object.keys(this.selectedAreaData).length > 0) {
                        if (this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_LVL == '여유') {
                            this.selectedAreaData.popKey = '1';
                        }
                        if (this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_LVL == '보통') {
                            this.selectedAreaData.popKey = '2';
                        }
                        if (this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_LVL == '약간 붐빔') {
                            this.selectedAreaData.popKey = '3';
                        }
                        if (this.selectedAreaData.LIVE_PPLTN_STTS[0].AREA_CONGEST_LVL == '붐빔') {
                            this.selectedAreaData.popKey = '4';
                        }
                        !!this.selectedAreaData.WEATHER_STTS[0] ? this.selectedAreaData.WEATHER_STTS[0].key = this.selectedAreaData.key
																	: this.selectedAreaData.WEATHER_STTS[0] = {key: this.selectedArea.key};
                    } else {
                        alert('데이터 호출 중 오류가 발생했습니다. 잠시후 다시 시도해주세요.');
                        this.$eventBus.$emit("ChangeLoading::State::Loaded");
                        this.clearCache();
                    }

                    this.$eventBus.$emit("ChangeLoading::State::Loaded");

                    // console.log('selectedAreaData', this.selectedAreaData);

                    this.showTopBar = true;
                    this.selectArea();
                }
            });
    	},
    	xmlParser(xmlDoc, elName){
        	let list = [];
        	let ii = 0;
        	let el = xmlDoc.getElementsByTagName(elName);
			if(!!el) {
				for(let pNode of el){
					if(ii === 0){
						ii++;
						continue;
					}
					let map = {};
					for(let cNode of pNode.children){
						if(cNode.children.length > 0){
							map[cNode.nodeName] = [];
							for(let ccNode of cNode.children){
								let detailMap = {};
								for(let cccNode of ccNode.children){
									detailMap[cccNode.nodeName] = cccNode.textContent;
								}
								map[cNode.nodeName].push(detailMap);
							}
						} else {
							map[cNode.nodeName] = cNode.textContent;
						}
					}
					list.push(map);
				}
			}
        	return list;
    	},
    	xmlGetData(xmlDoc, elName) {
    	    let el = xmlDoc.getElementsByTagName(elName);
			let val = '';
			if(!!el) {
				val = el[0].textContent;
			}
    	    return val;
    	},
    	xmlGetDataMap(xmlDoc, elName) {
            let el = xmlDoc.getElementsByTagName(elName);
            let map = new Map();
			if(!!el) {
				for(let key in el[0].children) {
					if(!!el[0].children[key].textContent) {
						map.set(el[0].children[key].localName, el[0].children[key].textContent)
					}
				}
			}
            return map;
        },
    	showSelectedSeoulmapPop() {
    	    this.$eventBus.$emit("SeoulmapMapCtrl::show-seoulmap-pop");
    	},
    	// hover html -> 이미지는 서울시 실시간 도시데이터에서 가져옴.
    	makeHoverInfo(areaKey) {
    	    let width = 300;
    	    let height = 200;
    	    if($_WC.viewScale > 1) {
    	        width = 720;
    	        height = 400;
    	    }
    	    let contentHtml = "<div class='popup_st01' style='width:100%;height:100%;'><div class='popup_wrap'><div class='title'><span class='t02'>" + areaKey + "</span></div><div class='traffic_box' style='background: #fff;'><p><img style='width:" + width + "px; height: " + height + "px;' src='https://data.seoul.go.kr/SeoulRtd/images/hotspot/" + encodeURIComponent(areaKey) + ".jpg'></p></div></div></div>"

    	    // 퍼블 팝업
			let contentHtml2 = "<div class='popup_st01' style='width:100%;height:100%;'><div class='popup_wrap'><div class='title'><span class='t01'>" + areaKey + "</span></div><div class='photo_list' style='margin-top:4%;'><ul><li><img src='https://data.seoul.go.kr/SeoulRtd/images/hotspot/" + encodeURIComponent(areaKey) + ".jpg' alt='사진' style='width:" + width + "px; height: " + height + "px;'></li></ul></div>"

    	    return new naver.maps.InfoWindow({
                content: contentHtml2,
            });
    	},


    	makeHtmlMarkerSeoul(addongNm, value, unit) {
            let dimClass = "dim10";
            let fontSize = '14px';
            if($_WC.viewScale > 1) {
                fontSize = '34px'
            }
            let dpVal = value;
            if(typeof value === 'undefined' || value === '-' || value === '' || dimClass === 'dim05') {
                dpVal = "점검중";
            }

            let html = '<div class="dim_info_real ' + dimClass + '">';
            html += '<p class="dim_no">' + dpVal;
            if(dpVal !== '점검중') {
                html += '<span>' + unit + '</span>';
            }
            html += '</p>';
            html += '<p class="dim_pl">' + addongNm + '</p>';
            html += '</div>';
			// console.log('html', html);
            return html;
        },

		clearCache() {
			let url = $_WC.apiBaseURL + '/seoulCity/realcity/clear';
			this.instance.get(url).then((res) => {
				return res.status;
			});
		},
    },
    mixins: [naverMapShareMixins],
}
</script>
